import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { LanguageSelector } from '@shared/components/language-selector/language-selector';

import { DEFAULT_BRAND, PublicBrand } from '../public-brand';

@Component({
  selector: 'app-public-shell',
  imports: [RouterOutlet, TranslatePipe, LanguageSelector],
  templateUrl: './public-shell.html',
  styleUrl: './public-shell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicShell {
  /**
   * Read from a snapshot rather than a stream: each brand has its own route
   * branch, so switching brands re-creates this component.
   */
  protected readonly brand: PublicBrand =
    inject(ActivatedRoute).snapshot.data['brand'] ?? DEFAULT_BRAND;

  protected readonly year = new Date().getFullYear();
}
